import React from "react";

function Home() {
  return <h1 className="home">Services Page</h1>;
}

export default Home;
